import { useState } from "react";
import { toast } from "sonner";
import { tradingService } from "@/services/marketService";
import { errorMessage } from "@/services/apiClient";
import { formatPrice } from "@/lib/format";
import { useLanguage } from "@/context/LanguageContext";

const num = (v) => Number(v) || 0;

export const defaultTargets = (side, base) => {
  if (!base) return { tp: 0, sl: 0 };
  return side === "sell"
    ? { tp: +(base * 0.99).toFixed(6), sl: +(base * 1.01).toFixed(6) }
    : { tp: +(base * 1.01).toFixed(6), sl: +(base * 0.99).toFixed(6) };
};

/** Estado e execução da ordem: mantém o TradePanel focado na apresentação. */
export const useTradeOrder = ({ asset, advanced, tp, sl, touched, onSuccess }) => {
  const { t } = useLanguage();
  const [busy, setBusy] = useState("");

  const targetsFor = (side) => {
    const auto = defaultTargets(side, (side === "sell" ? asset?.sell : asset?.buy) || 0);
    return { tp: touched.tp ? num(tp) : auto.tp, sl: touched.sl ? num(sl) : auto.sl };
  };

  const submit = async (side, quantity) => {
    setBusy(side);
    try {
      const payload = { asset_id: asset.id, side, quantity: num(quantity) };
      if (advanced) {
        const { tp: finalTp, sl: finalSl } = targetsFor(side);
        if (finalTp > 0) payload.take_profit = finalTp;
        if (finalSl > 0) payload.stop_loss = finalSl;
      }
      const p = await tradingService.order(payload);
      toast.success(`${side === "buy" ? t("trade.buyDone") : t("trade.sellDone")} · ${p.symbol} @ ${formatPrice(p.entry_price)}`);
      onSuccess?.();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy("");
    }
  };

  return { busy, submit };
};
